// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"854b4ad5","132":"115e050f","434":"f2954e9c","766":"aacb3a17","835":"5413045d"}[chunkId] + ".chunk.css";
};